"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterCount = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Counter = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n  label: CharacterCount;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n  label: CharacterCount;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var CharacterCount = function (_a) {
    var _b;
    var value = _a.value, color = _a.color, className = _a.className;
    return (react_1.default.createElement(Counter, { className: className, color: color },
        "\u73FE\u5728\u306E\u6587\u5B57\u6570",
        '　', (_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0));
};
exports.CharacterCount = CharacterCount;
var templateObject_1;
